/* eslint-disable import/prefer-default-export */
import { Streams } from '../../../Types';
import { conversationsActions } from '../..';
import { ConversationEventTypes, ParticipantWasRemovedFromConversation } from '../../../Types/Conversations/Events';
import { ParticipantWasRemovedFromConversationWrappedEvent } from '../../../Types/Conversations/WrappedEvents';
import { ConversationsActionTypes } from '../../Conversations/actions';

export const participantWasRemovedFromConversationHandler = (
    { conversationId, metadata, removedUserId }: Streams.ParticipantWasRemovedFromConversationStreamMessage,
    currentUserId: number,
    dispatch,
): void => {
    const { eventDate: RemovedDate, userId: RemoverUserId } = metadata;

    if (currentUserId === removedUserId) {
        dispatch({
            type: conversationsActions.SET_CONVERSATION_INACTIVE,
            payload: conversationId,
        } as ConversationsActionTypes);
    }

    dispatch({
        type: conversationsActions.SET_PARTICIPANT_INACTIVE,
        payload: {
            conversationId: conversationId,
            participantId: removedUserId,
        },
    } as ConversationsActionTypes);

    dispatch({
        type: conversationsActions.ADD_EVENT_TO_CONVERSATION,
        payload: {
            conversationId: conversationId,
            event: {
                type: ConversationEventTypes.ParticipantWasRemovedFromConversation,
                event: {
                    conversationId: conversationId,
                    metadata: {
                        eventDate: RemovedDate,
                        userId: RemoverUserId,
                    },
                    removedUserId: removedUserId,
                } as ParticipantWasRemovedFromConversation,
            } as ParticipantWasRemovedFromConversationWrappedEvent,
        },
    } as ConversationsActionTypes);
};
